import { default as _91_46_46_46all_930i5ctWJQq5Meta } from "/vercel/path0/pages/[...all].vue?macro=true";
import { default as log_45inCI5aO1iYinMeta } from "/vercel/path0/pages/auth/log-in.vue?macro=true";
import { default as log_45outrgjMlUcv0tMeta } from "/vercel/path0/pages/auth/log-out.vue?macro=true";
import { default as verifyyQG91iw7FDMeta } from "/vercel/path0/pages/auth/verify.vue?macro=true";
import { default as indexA0X6jXVry0Meta } from "/vercel/path0/pages/campaigns/index.vue?macro=true";
import { default as skaldjursveckorna1TaDlpP7dCMeta } from "/vercel/path0/pages/campaigns/skaldjursveckorna.vue?macro=true";
import { default as stockholm_45food_45weeksprv7OalTScMeta } from "/vercel/path0/pages/campaigns/stockholm-food-weeks.vue?macro=true";
import { default as indexC6zt8Vs9WsMeta } from "/vercel/path0/pages/city/index.vue?macro=true";
import { default as _91city_93E7DExxuSYXMeta } from "/vercel/path0/pages/events/[city].vue?macro=true";
import { default as indexuedj0fLb5OMeta } from "/vercel/path0/pages/events/index.vue?macro=true";
import { default as indexY8XyHDsiDLMeta } from "/vercel/path0/pages/fat/index.vue?macro=true";
import { default as _91city_93UzjNBFEcxKMeta } from "/vercel/path0/pages/giftcards/[city].vue?macro=true";
import { default as index54Xyfg7TdRMeta } from "/vercel/path0/pages/giftcards/index.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91city_932LxREmShK2Meta } from "/vercel/path0/pages/offers/[city].vue?macro=true";
import { default as index7pp5WpoXdvMeta } from "/vercel/path0/pages/offers/index.vue?macro=true";
import { default as indexG7XwsIruPAMeta } from "/vercel/path0/pages/posts/index.vue?macro=true";
import { default as singleyuAj5bxe6HMeta } from "/vercel/path0/pages/posts/single.vue?macro=true";
import { default as index0SmQEu5qr7Meta } from "/vercel/path0/pages/res-req/index.vue?macro=true";
import { default as _91city_93cfuXUJlvlnMeta } from "/vercel/path0/pages/restaurants/[city].vue?macro=true";
import { default as _91slug_93iqOIYSusvnMeta } from "/vercel/path0/pages/restaurants/[slug].vue?macro=true";
import { default as _91tag_93l5yXRUX76mMeta } from "/vercel/path0/pages/restaurants/[tag].vue?macro=true";
import { default as indexkOmdG3yThEMeta } from "/vercel/path0/pages/restaurants/index.vue?macro=true";
import { default as indexDqV3Lxa5AvMeta } from "/vercel/path0/pages/search/index.vue?macro=true";
import { default as profileGl5mqoo5nGMeta } from "/vercel/path0/pages/user/profile.vue?macro=true";
export default [
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue").then(m => m.default || m)
  },
  {
    name: "auth-log-in",
    path: "/logga-in",
    component: () => import("/vercel/path0/pages/auth/log-in.vue").then(m => m.default || m)
  },
  {
    name: "auth-log-out",
    path: "/logga-ut",
    component: () => import("/vercel/path0/pages/auth/log-out.vue").then(m => m.default || m)
  },
  {
    name: "auth-verify",
    path: "/verifiera",
    component: () => import("/vercel/path0/pages/auth/verify.vue").then(m => m.default || m)
  },
  {
    name: "campaigns",
    path: "/exclusive",
    component: () => import("/vercel/path0/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-skaldjursveckorna",
    path: "/exclusive/skaldjursveckorna",
    component: () => import("/vercel/path0/pages/campaigns/skaldjursveckorna.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-stockholm-food-weeks",
    path: "/exclusive/stockholm-food-weeks",
    component: () => import("/vercel/path0/pages/campaigns/stockholm-food-weeks.vue").then(m => m.default || m)
  },
  {
    name: "city",
    path: "/city",
    component: () => import("/vercel/path0/pages/city/index.vue").then(m => m.default || m)
  },
  {
    name: "events-city",
    path: "/evenemang/:city()",
    component: () => import("/vercel/path0/pages/events/[city].vue").then(m => m.default || m)
  },
  {
    name: "events",
    path: "/evenemang",
    component: () => import("/vercel/path0/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: "fat",
    path: "/lediga-bord",
    meta: indexY8XyHDsiDLMeta || {},
    component: () => import("/vercel/path0/pages/fat/index.vue").then(m => m.default || m)
  },
  {
    name: "giftcards-city",
    path: "/presentkort/:city()",
    component: () => import("/vercel/path0/pages/giftcards/[city].vue").then(m => m.default || m)
  },
  {
    name: "giftcards",
    path: "/presentkort",
    component: () => import("/vercel/path0/pages/giftcards/index.vue").then(m => m.default || m)
  },
  {
    name: "start",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "offers-city",
    path: "/erbjudanden/:city()",
    meta: _91city_932LxREmShK2Meta || {},
    component: () => import("/vercel/path0/pages/offers/[city].vue").then(m => m.default || m)
  },
  {
    name: "offers",
    path: "/erbjudanden",
    meta: index7pp5WpoXdvMeta || {},
    component: () => import("/vercel/path0/pages/offers/index.vue").then(m => m.default || m)
  },
  {
    name: "posts",
    path: "/posts",
    component: () => import("/vercel/path0/pages/posts/index.vue").then(m => m.default || m)
  },
  {
    name: "posts-single",
    path: "/posts/single",
    component: () => import("/vercel/path0/pages/posts/single.vue").then(m => m.default || m)
  },
  {
    name: "res-req",
    path: "/bokningsforfragan",
    component: () => import("/vercel/path0/pages/res-req/index.vue").then(m => m.default || m)
  },
  {
    name: "restaurants-city",
    path: "/restauranger/:city()",
    component: () => import("/vercel/path0/pages/restaurants/[city].vue").then(m => m.default || m)
  },
  {
    name: "restaurants-slug",
    path: "/restaurang/:slug()",
    component: () => import("/vercel/path0/pages/restaurants/[slug].vue").then(m => m.default || m)
  },
  {
    name: "restaurants-city-tag",
    path: "/restauranger/:city()/:tag()",
    component: () => import("/vercel/path0/pages/restaurants/[tag].vue").then(m => m.default || m)
  },
  {
    name: "restaurants",
    path: "/restauranger",
    component: () => import("/vercel/path0/pages/restaurants/index.vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/vercel/path0/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: "user-profile",
    path: "/profil",
    component: () => import("/vercel/path0/pages/user/profile.vue").then(m => m.default || m)
  }
]